const routes = {
  getStatus: "bot/status",
  getList: "bot/list",
  agentPermission: "bot/permission",
  getPrepaidStatus: "bot/prepaid/status",
  getPrepaidList: "bot/prepaid/list",
};

export default routes;
